import { render } from "./AppBottomComponent.vue?vue&type=template&id=74d1198a&scoped=true"
import script from "./AppBottomComponent.vue?vue&type=script&lang=js"
export * from "./AppBottomComponent.vue?vue&type=script&lang=js"

import "./AppBottomComponent.vue?vue&type=style&index=0&id=74d1198a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d1198a"]])

export default __exports__